import Close from '@/assets/close.svg'
import {type IconProps} from './types'

export const CloseIcon = ({className}: IconProps) => <Close className={className} />
